/** Unmatched demand's words for wire values: one map each, shared by the filter, the dialog and the badges. */

import type { DemandArchiveReason, DemandStatus, UnmatchedDemandItem } from '@/api/types';
import { formatDate } from '@/ui/format';

export const SOURCE_LABELS: Record<string, string> = { advisor: 'Advisor', research: 'Research' };

export const ARCHIVE_REASON_LABELS: Record<DemandArchiveReason, string> = {
  opportunity: 'Became an opportunity',
  covered: 'Covered by an asset',
  not_relevant: 'Not relevant',
};

export const ARCHIVE_REASONS = Object.keys(ARCHIVE_REASON_LABELS) as DemandArchiveReason[];

export const DEMAND_STATUS_LABELS: Record<DemandStatus, string> = { open: 'Open', archived: 'Archived', all: 'All' };

/** The empty state's heading and line for each view. */
export const DEMAND_EMPTY: Record<DemandStatus, { title: string; text: string }> = {
  open: { title: 'No open demand', text: 'When a run finds no strong match, its needs show here for a year.' },
  archived: { title: 'No archived demand', text: 'Entries archived from the Open view show here, with the reason.' },
  all: { title: 'No unmatched demand', text: 'When a run finds no strong match, its needs show here for a year.' },
};

/** "Archived · Not relevant"; a reason the screen does not know reads as itself. */
export function archivedLabel(item: Pick<UnmatchedDemandItem, 'archive_reason'>): string {
  const reason = item.archive_reason ? (ARCHIVE_REASON_LABELS[item.archive_reason] ?? item.archive_reason) : null;
  return reason ? `Archived · ${reason}` : 'Archived';
}

/** "by Ana Souza on Oct 20, 2026", with "Not recorded" for an archiver the server no longer names. */
export function archivedHint(item: Pick<UnmatchedDemandItem, 'archived_at' | 'archived_by'>): string {
  const when = item.archived_at ? ` on ${formatDate(item.archived_at)}` : '';
  return `by ${item.archived_by ?? 'Not recorded'}${when}`;
}
